import { FilterCondition } from '@helo/cms'

/** Date filter condition options (Date, Range, Is Blank, Is Present). Kept in a separate file to avoid circular imports with DateFilterEditor. */
export const DATE_FILTER_CONDITION_OPTIONS: Array<{
  label: string
  value: string
}> = [
  { label: 'Date', value: FilterCondition.equals },
  { label: 'Range', value: FilterCondition.inRange },
  { label: 'Is Blank', value: FilterCondition.blank },
  { label: 'Is Present', value: FilterCondition.notBlank },
]

/** Extended date filter options including Is Before, Is After, Excludes. Order: date, range, is before, is after, excludes, is present, is blank. */
export const DATE_FILTER_CONDITION_OPTIONS_EXTENDED: Array<{
  label: string
  value: string
}> = [
  { label: 'Date', value: FilterCondition.equals },
  { label: 'Range', value: FilterCondition.inRange },
  { label: 'Is Before', value: FilterCondition.lessThan },
  { label: 'Is After', value: FilterCondition.greaterThan },
  { label: 'Excludes', value: FilterCondition.notEqual },
  { label: 'Is Present', value: FilterCondition.notBlank },
  { label: 'Is Blank', value: FilterCondition.blank },
]

/** Cube analytics date filters (`CubeDateTimeFilter` → `inDateRange`). */
export const CUBE_DATE_FILTER_CONDITION_OPTIONS: Array<{
  label: string
  value: string
}> = [{ label: 'Range', value: FilterCondition.inRange }]
